import "../../../../src/content/shic-od-spanish/shic-od-es.scss";
import * as React from 'react';
export default {
  React
};